import React, { useEffect, useState } from 'react';
import {
    Typography,
    Box,
    Stack,
    Grid,
    Paper,
    Avatar,
    alpha,
    useTheme,
} from '@mui/material';
import {
    FolderOpen,
    Description,
    CheckCircle,
    Payments,
} from '@mui/icons-material';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer,
    Tooltip,
    CartesianGrid,
} from 'recharts';
import { StatsCard } from '../components/StatsCard';
import { useAuthStore } from '../../../store/useAuthStore';
import { FacturesTable } from '../../billing/components/FacturesTable';
import { DossierList } from '../../orders/components/DossierList';
import apiClient from '../../../services/api-client';

const chartData = [
    { name: 'Jan', total: 1200 },
    { name: 'Fév', total: 2100 },
    { name: 'Mar', total: 1800 },
    { name: 'Avr', total: 2400 },
    { name: 'Mai', total: 1700 },
    { name: 'Jun', total: 3100 },
];

const recentSales = [
    { name: 'Olivia Martin', email: 'olivia.martin@email.com', amount: '+1 999 000 FCFA' },
    { name: 'Jackson Lee', email: 'jackson.lee@email.com', amount: '+39 000 FCFA' },
    { name: 'Isabella Nguyen', email: 'isabella.nguyen@email.com', amount: '+299 000 FCFA' },
    { name: 'Jacob Mondaha', email: 'jacob@miracle.com', amount: '+450 000 FCFA' },
];

export function DashboardPage() {
    const theme = useTheme();
    const user = useAuthStore((state) => state.user);

    const [loading, setLoading] = useState(true);
    const [kpis, setKpis] = useState({});
    const [monthlyData, setMonthlyData] = useState([]);
    const [topClients, setTopClients] = useState([]);
    const [factures, setFactures] = useState([]);
    const [dossiers, setDossiers] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    async function fetchDashboardData() {
        try {
            const [facturesRes, dossiersRes] = await Promise.all([
                apiClient.get('/api/invoices'),
                apiClient.get('/api/orders'),
            ]);

            setFactures(facturesRes.data.content);
            setTotalPages(facturesRes.data.totalPages);
            setDossiers(dossiersRes.data);
        } catch (err) {
            console.error("Erreur lors du chargement du dashboard:", err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Box>
            {/* Titre */}
            <Typography
                variant="h5"
                sx={{
                    fontFamily: "'Cormorant Garamond', serif",
                    color: 'secondary.main',
                    fontWeight: 700,
                    mb: 3,
                }}
            >
                Bienvenue, {user?.username || 'Utilisateur'}
            </Typography>

            {/* ── Cartes de statistiques ── */}
            <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" sx={{ mb: 3, gap: 3 }}>
                <StatsCard
                    title="Dossiers Actifs"
                    value="32"
                    description="sur 47 total"
                    icon={<FolderOpen fontSize="small" />}
                    sx={{ maxWidth: '20%' }}
                />
                <StatsCard
                    title="Factures en Attente"
                    value="28"
                    description="sur 89 total"
                    icon={<Description fontSize="small" />}
                />
                <StatsCard
                    title="Factures Payées"
                    value="54"
                    description="Paiements confirmés"
                    icon={<CheckCircle fontSize="small" />}
                />
                <StatsCard
                    title="Revenu Mensuel"
                    value="12.050.000"
                    description="+12.5% vs mois dernier"
                    icon={<Payments fontSize="small" />}
                />
            </Box>

            <Box sx={{ mt: 4 }}>
                <DossierList
                />
            </Box>
            <Box sx={{ mt: 4 }}>
                <FacturesTable
                    data={factures}
                    page={page}
                    totalPages={totalPages}
                />
            </Box>
        </Box>
    );
}